import { ReactElement } from "react";
import ReactJoyride, { CallBackProps, Props } from "react-joyride";
import "./index.scss";
import { AuthZGuidedTourProps } from "./utils";
import { iif } from "src/common/utils/functions";

export default function AuthZGuidedTour(props: AuthZGuidedTourProps): ReactElement {
  const guidedTourProps: Props = {
    steps: props.steps,
    run: props.run,
  };

  function handleGuideCallback(data: CallBackProps) {
    iif(function closeGuidedTourOnClickingOutsideTourTooltipOrClickingEscape() {
      const { action } = data;
      if (action === "close") {
        props.setTourState({ run: false });
      }
    });
  }

  return (
    <ReactJoyride
      continuous={true}
      showProgress={true}
      showSkipButton={true}
      hideCloseButton={true}
      disableOverlayClose={true}
      locale={{
        next: "Next ->",
        last: "Close",
        skip: "Skip tour",
      }}
      callback={handleGuideCallback}
      {...guidedTourProps}
    />
  );
}
